module.exports = __webpack_public_path__ + "img/exam_back.6763207e.png";